import React, { Component } from 'react';
import { Grid, Col, Row } from 'react-bootstrap';
import i18n from 'kodyl-js/i18n/react';
import DocumentMeta from 'react-document-meta';

@i18n
class Partners extends Component {
  render() {
    return (
      <DocumentMeta title={this.i18n('Partners')} extend>
        <Grid>
          <Row>
            <Col xs={12}>
              <h1>{this.i18n('Partners')}</h1>
              <p>
                Driver du et website eller er du udgiver af en app, hvor dine
                brugere er interesserede i lejeboliger? Så tag kontakt til os om
                muligheden for et markedsføringssamarbejde.
              </p>
            </Col>
          </Row>
        </Grid>
      </DocumentMeta>
    );
  }
}

export default Partners;
